import { PartagePlusBadge } from 'app/components/partage-plus-badge';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useLoanDiscount } from 'app/hooks/use-loan-discount';
import { localeAwareFormat } from 'app/lib/date';
import { createTheme as createDSTheme } from 'app/shopify';
import { isLoanDiscountActive } from 'app/utils/loan-discount';
import { IconChevronRight } from '@tabler/icons-react-native';
import React from 'react';
import { Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';

const theme = createDSTheme();

export function UnlockFullExperienceCard({ onPress, variant }: { onPress: () => void; variant: 'small' | 'large' }) {
  const { t } = useTranslation('landing-page');
  const isLarge = variant === 'large';
  const { discountDeadline } = useLoanDiscount();
  const hasActiveLoanDiscount = isLoanDiscountActive(discountDeadline);

  return (
    <Pressable
      accessibilityLabel={t('unlockFullExperience.accessibilityLabel')}
      accessibilityRole="button"
      onPress={onPress}
      style={{
        alignItems: 'center',
        backgroundColor: theme.colors['surface.brand.secondary-5.subtle'],
        borderRadius: theme.borderRadii['radius.lg'],
        flexDirection: 'row',
        gap: theme.spacing[isLarge ? 'spacing.general.x4' : 'spacing.general.x3'],
        justifyContent: 'center',
        paddingHorizontal: theme.spacing[isLarge ? 'spacing.general.x6' : 'spacing.general.x4'],
        paddingVertical: theme.spacing[isLarge ? 'spacing.general.x6' : 'spacing.general.x3'],
      }}
    >
      <PartagePlusBadge />
      {isLarge ? (
        <Row alignItems="center" flex={1} gap="spacing.general.x4">
          <Text color="text.primary" fontSize={18} fontWeight="700" lineHeight={22} numberOfLines={1}>
            {t('unlockFullExperience.title')}
          </Text>
          {hasActiveLoanDiscount && discountDeadline ? (
            <Row
              alignItems="center"
              backgroundColor="surface.primary-neutral"
              borderRadius="radius.full"
              gap="spacing.general.x1"
              paddingHorizontal="spacing.general.x4"
              paddingVertical="spacing.general.x1"
            >
              <Text color="text.primary" fontSize={12} fontWeight="700" lineHeight={22}>
                {t('unlockFullExperience.discount')}
              </Text>
              <Text color="text.primary" fontSize={12} lineHeight={14}>
                {t('unlockFullExperience.discountDeadline', {
                  date: localeAwareFormat(discountDeadline, t('dateFormat_MMMMd', { ns: 'common' })),
                })}
              </Text>
            </Row>
          ) : null}
        </Row>
      ) : (
        <Column flex={1}>
          <Text color="text.primary" fontSize={14} fontWeight="700">
            {t('unlockFullExperience.title')}
          </Text>
        </Column>
      )}
      <IconChevronRight color={theme.colors['icon.primary']} size={isLarge ? 32 : 30} strokeWidth={1.5} />
    </Pressable>
  );
}
